function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivisionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3.2,
    fill: "#E5A503",
    style: {
      fill: "#E5A503",
      fill: "color(display-p3 0.8980 0.6471 0.0118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9969 8.50156C12.3835 8.50156 12.6969 8.18816 12.6969 7.80156C12.6969 7.41496 12.3835 7.10156 11.9969 7.10156C11.6103 7.10156 11.2969 7.41496 11.2969 7.80156C11.2969 8.18816 11.6103 8.50156 11.9969 8.50156Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09766 12H16.8977",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9969 16.902C12.3835 16.902 12.6969 16.5886 12.6969 16.202C12.6969 15.8154 12.3835 15.502 11.9969 15.502C11.6103 15.502 11.2969 15.8154 11.2969 16.202C11.2969 16.5886 11.6103 16.902 11.9969 16.902Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivisionIcon);
export default __webpack_public_path__ + "static/media/DivisionIcon.09e2a89a2fe8635f6f2952c04c109241.svg";
export { ForwardRef as ReactComponent };